import { render, staticRenderFns } from "./OnboardingTerms.vue?vue&type=template&id=fada80f6&"
import script from "./OnboardingTerms.vue?vue&type=script&lang=js&"
export * from "./OnboardingTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports